import React from 'react';

import { Field, FieldArray, Form, getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { SelectField } from '../../../../common/components/ReduxFormField';
import { Col, Row } from 'react-bootstrap';
import { Button, ButtonBar } from '../../../../common/components';

const SANCTION_OPTIONS = [
  {
    value: 'aig',
    label: 'AIG',
  },
  {
    value: 'proexe',
    label: 'Pro Exe',
  },
  {
    value: 'none',
    label: 'No Sanctions(all insured marked as  passed)',
  },
];
const SanctionSelect = ({ input }) => {
  const { scheme_name } = input.value;
  return (
    <Row>
      <Col sm={6}>
        <Field
          label={scheme_name}
          labelSize={4}
          fieldSize={3}
          name={`${input.name}.sanctions_provider`}
          placeholder="Sanction Provider"
          options={SANCTION_OPTIONS}
          component={SelectField}
        />
      </Col>
    </Row>
  );
};

const SanctionFieldArray = ({ fields }) => {
  return (
    <>
      {fields.map((field) => (
        <div>
          <Field name={field} component={SanctionSelect} />
        </div>
      ))}
    </>
  );
};
const SchemeSanctionsForm = ({ handleSubmit, onUpdate }) => {
  return (
    <Form onSubmit={handleSubmit(onUpdate)}>
      <FieldArray name={'meta.sanctions'} component={SanctionFieldArray} />

      <ButtonBar>
        <Button type={'submit'} bsStyle={'primary'} className={'pull-right'}>
          Save
        </Button>
      </ButtonBar>
    </Form>
    // </div>
  );
};

const getInitialValues = (schemes) => () => {
  return {
    meta: {
      sanctions: schemes?.map((scheme) => ({
        scheme_id: scheme.id,
        scheme_name: `${scheme?.attributes?.name} v${scheme?.attributes?.version} (${
          scheme?.attributes?.status
        })`,
        sanctions_provider: scheme?.attributes?.metadata?.sanctions_provider,
      })),
    },
  };
};

const FORM_NAME = 'EditSchemeSanctions';
export default compose(
  connect((state, props) => {
    return {
      formValues: getFormValues(FORM_NAME)(state),
      initialValues: getInitialValues(props?.schemes ?? [])(state),
    };
  }),
  reduxForm({ form: FORM_NAME }),
)(SchemeSanctionsForm);
